import React from 'react';
import {ThinkscapeTable} from '../../components/common';
import {fetchQuizResults} from '../../api';
import {calculateScore, getNumberOfCorrectAnswers, getTotalNumberOfPoints} from './UserReports/utils';
import Button from '@material-ui/core/Button';

export default function QuizResult(props) {
    const {quizId, historyAction} = props;
    return (
        <ThinkscapeTable
            itemName="users"
            hiddenFields={['actions']}
            getFieldsMapping={(user) => (
                {
                    mostRecentDate: user.mostRecentDate.$date,
                    username: user.userName,
                    email: user.email,
                    platformUserId: user.platformUserId,
                    mostRecentScore: user.mostRecentScore,
                    result: user.attempts[user.attempts.length-1],
                    history: '',
                })
            }
            fetchRecords={(args) => fetchQuizResults(quizId, {
                ...args,
            })}
            fieldsSettings={
                {
                    mostRecentDate: {
                        sortable: true,
                        fieldText: 'Most Recent Attempt',
                        formatData: cell => {
                            let recentDate = new Date (cell);
                            let options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
                            return recentDate.toLocaleString(undefined, options);
                        }
                    },
                    username: {
                        sortable: true,
                        fieldText: 'Name',
                        formatData: cell => unescape(cell)
                    },
                    email: {
                        sortable: true,
                        fieldText: 'Email',
                        formatData: cell => unescape(cell)
                    },
                    platformUserId: {
                        sortable: true,
                        fieldText: 'User ID',
                    },
                    mostRecentScore:{
                        sortable: true,
                        fieldText: 'Score',
                        formatData: (cell, row) => row.record.attempts[row.record.attempts.length-1].complete ?
                            `${cell}/${getTotalNumberOfPoints(row.record.attempts[row.record.attempts.length-1].questions)}` :
                            '-'
                    },
                    result:{
                        fieldText: 'Result',
                        formatData: cell => cell.complete ?
                            calculateScore(cell) >= cell.options.passFailThreshold ? 'Pass' : 'Fail'
                            : 'Incomplete'
                    },
                    history: {
                        fieldText: 'Detailed Report (By Attempt #)',
                        noPadding: true,
                        formatData: (cell, row) => {
                            let list = [];
                            for (let i = 1; i <= row.record.attempts.length; i++) {
                                list[i] = row.record.attempts[i-1].complete ? (
                                    <Button
                                        key={`${row.id}-attempt-${i}`}
                                        onClick={() => historyAction(row.record.attempts[i-1]._id.$oid)}
                                        color="primary" variant="text">
                                        {i}
                                    </Button>) : null;
                            }
                            return (
                                <div className="table-actions">
                                    {list}
                                </div>
                            );
                        },
                    },
                }
            }
        />
    );
}
